import React, { FC, ReactNode, useEffect, useRef } from 'react';
import { motion, useAnimation, useInView } from 'framer-motion';

interface Props {
  children: ReactNode;
}

const Reveal: FC<Props> = ({ children }) => {
  const ref = useRef(null);

  const isInView = useInView(ref, { once: true });

  const scrollController = useAnimation();

  useEffect(() => {
    if (isInView) {
      scrollController.start('end');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInView]);

  return (
    <section ref={ref}>
      <motion.div
        variants={{
          start: { opacity: 0, y: 75 },
          end: { opacity: 1, y: 0 },
        }}
        initial="start"
        animate={scrollController}
        transition={{
          duration: 0.5,
          delay: 0.25,
          //   bounce: 1,
        }}
      >
        {children}
      </motion.div>
    </section>
  );
};

export default Reveal;
